module.exports = {
      id: "listicle-usage",
      viewBox: "0 0 10.45 17.376",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#listicle",
      toString: function () {
        return this.url;
      }
    }